import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { actions } from "./slice";
import * as API from "../../../../../services/apis";

export function* handleFetchReport({ payload }) {
  try {
    const res = yield call(API.fetchParsedReport, payload);
    const { data } = res;
    yield put(actions.fetchReportDataSuccess(data));
  } catch (err) {
    yield put(actions.fetchReportDataFailure(err?.response?.data));
  }
}

export function* handleFetchReportSasUrl({ payload }) {
  try {
    const res = yield call(API.fetchPdfForOrder, payload);
    const { data } = res;
    yield put(actions.fetchReportSasUrlSuccess(data));
  } catch (err) {
    yield put(actions.fetchReportSasUrlFailure(err?.response?.data));
  }
}

export function* handleSaveChangedData({ payload }) {
  try {
    const res = yield call(API.saveAndValidate, payload.data);
    const { data } = res;
    yield put(actions.saveChangedDataSuccess(data));
    payload.onSuccess(data);
  } catch (err) {
    yield put(actions.saveChangedDataFailure(err?.response?.data));
    payload.onFailure();
  }
}

export function* handleSubmitReportData({ payload }) {
  try {
    yield call(API.submitReportData, payload);
    yield put(actions.submitReportDataSuccess());
    payload.onSuccess();
  } catch (err) {
    yield put(actions.submitReportDataFailure(err?.response?.data));
    payload.onFailure();
  }
}

export function* handleReviewReportAction({ payload }) {
  try {
    yield call(API.markAsNotTestedOrMissing, payload);
    yield put(actions.reviewReportActionSuccess());
    payload.onSuccess();
  } catch (err) {
    yield put(actions.reviewReportActionFailure(err?.response?.data));
    payload.onFailure();
  }
}

export function* reviewReportSaga() {
  yield takeLatest(actions.fetchReportData.type, handleFetchReport);
  yield takeLatest(actions.fetchReportSasUrl.type, handleFetchReportSasUrl);
  yield takeEvery(actions.saveChangedData.type, handleSaveChangedData);
  yield takeEvery(actions.submitReportData.type, handleSubmitReportData);
  yield takeEvery(actions.reviewReportAction.type, handleReviewReportAction);

}
